module.exports = global["_"] = require("-!./lodash.js");